import React from 'react';
import {Camera, Pencil} from 'lucide-react';
import {brand, brandFont} from '../../brand';

export type InputMode = 'write' | 'photo';

export const InputModeToggle: React.FC<{selected: InputMode}> = ({selected}) => (
  <div
    style={{
      padding: 6,
      background: 'rgba(0,0,0,0.5)',
      borderRadius: 28,
      border: '1.5px solid rgba(255,255,255,0.08)',
      display: 'flex',
      gap: 12,
    }}
  >
    <ModeChip label="Write" Icon={Pencil} selected={selected === 'write'} />
    <ModeChip label="Photo" Icon={Camera} selected={selected === 'photo'} />
  </div>
);

const ModeChip: React.FC<{
  label: string;
  Icon: React.ComponentType<{size?: number; color?: string; strokeWidth?: number}>;
  selected: boolean;
}> = ({label, Icon, selected}) => {
  const fg = selected ? brand.textPrimary : 'rgba(255,255,255,0.56)';
  return (
    <div
      style={{
        flex: 1,
        padding: '20px 24px',
        borderRadius: 22,
        background: selected ? brand.primaryLight : 'transparent',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 12,
        fontFamily: brandFont,
        fontWeight: 600,
        fontSize: 24,
        color: fg,
      }}
    >
      <Icon size={26} color={fg} strokeWidth={2.4} />
      {label}
    </div>
  );
};
